// LiveStreamPusherHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';

import {
  PRESET_SD,
  ExclusivePrivateStatus as ExclusivePrivateStatusConstant,
} from '../resource/liveStreamConstants.js';

export class LiveStreamPusherHandler extends React.PureComponent {
  canSubscribePresenceStreamExclusive = () => {
    const {
      meId,
      exclusivePrivateStatus,
      exclusivePrivateBuyerId,
      isLivestreamModerator,
    } = this.props;
    const isExclusivePrivateBuyer =
      meId != null && meId === exclusivePrivateBuyerId;
    return (
      ExclusivePrivateStatusConstant.PERFORMING === exclusivePrivateStatus &&
      (isExclusivePrivateBuyer || isLivestreamModerator)
    );
  };
  componentDidMount() {
    const {
      streamId,
      pusherPreset,
      fundingId,
      meId,
      subscribeStreamChannel,
      subscribePrivateStreamViewerV2Channel,
      subscribePrivateGoalV2Channel,
      shouldSubscribeStreamChannel,
      subscribePresenceStreamExclusive,
    } = this.props;
    if (this.canSubscribePresenceStreamExclusive()) {
      subscribePresenceStreamExclusive({
        streamId,
      });
    }
    if (shouldSubscribeStreamChannel) {
      subscribeStreamChannel({
        streamId,
      });
    }
    subscribePrivateStreamViewerV2Channel({
      streamId,
      preset: pusherPreset,
    });
    subscribePrivateGoalV2Channel({
      goalId: fundingId,
      userId: meId,
    });
  }
  componentDidUpdate(prevProps) {
    const {
      streamId,
      pusherPreset,
      meId,
      fundingId,
      shouldSubscribeStreamChannel,
      subscribePrivateStreamViewerV2Channel,
      unsubscribePrivateStreamViewerV2Channel,
      subscribePrivateGoalV2Channel,
      unsubscribePrivateGoalV2Channel,
      unsubscribeStreamChannel,
      exclusivePrivateStatus,
      exclusivePrivateBuyerId,
      isLivestreamModerator,
      subscribePresenceStreamExclusive,
      unsubscribePresenceStreamExclusive,
    } = this.props;
    if (
      meId !== prevProps.meId ||
      exclusivePrivateBuyerId !== prevProps.exclusivePrivateBuyerId ||
      isLivestreamModerator !== prevProps.isLivestreamModerator ||
      exclusivePrivateStatus !== prevProps.exclusivePrivateStatus
    ) {
      if (this.canSubscribePresenceStreamExclusive()) {
        subscribePresenceStreamExclusive({
          streamId,
        });
      } else {
        unsubscribePresenceStreamExclusive({
          streamId,
        });
      }
    }
    if (prevProps.pusherPreset !== pusherPreset) {
      unsubscribePrivateStreamViewerV2Channel({
        streamId,
        preset: prevProps.pusherPreset,
      });
      subscribePrivateStreamViewerV2Channel({
        streamId,
        preset: pusherPreset,
      });
    }
    if (meId !== prevProps.meId) {
      unsubscribePrivateGoalV2Channel({
        goalId: fundingId,
        userId: prevProps.meId,
      });
      subscribePrivateStreamViewerV2Channel({
        streamId,
        preset: pusherPreset,
      });
      subscribePrivateGoalV2Channel({
        userId: meId,
        goalId: fundingId,
      });
    }
    if (fundingId !== prevProps.fundingId) {
      unsubscribePrivateGoalV2Channel({
        userId: meId,
        goalId: prevProps.fundingId,
      });
      subscribePrivateGoalV2Channel({
        userId: meId,
        goalId: fundingId,
      });
    }
    if (
      !shouldSubscribeStreamChannel &&
      shouldSubscribeStreamChannel !== prevProps.shouldSubscribeStreamChannel
    ) {
      unsubscribeStreamChannel({ streamId });
    }
  }
  componentWillUnmount() {
    const {
      streamId,
      meId,
      fundingId,
      pusherPreset,
      unsubscribePrivateStreamViewerV2Channel,
      unsubscribeStreamChannel,
      unsubscribePrivateGoalV2Channel,
      unsubscribePresenceStreamExclusive,
    } = this.props;
    unsubscribePresenceStreamExclusive({
      streamId,
    });
    unsubscribeStreamChannel({
      streamId,
    });
    unsubscribePrivateStreamViewerV2Channel({
      streamId,
      preset: pusherPreset,
    });
    unsubscribePrivateGoalV2Channel({
      userId: meId,
      goalId: fundingId,
    });
  }
  render() {
    return null;
  }
}

LiveStreamPusherHandler.propTypes = {
  streamId: PropTypes.string,
  pusherPreset: PropTypes.string,
  meId: PropTypes.string,
  fundingId: PropTypes.string,
  subscribeStreamChannel: PropTypes.func,
  subscribePrivateStreamViewerV2Channel: PropTypes.func,
  unsubscribeStreamChannel: PropTypes.func,
  unsubscribePrivateStreamViewerV2Channel: PropTypes.func,
  subscribePrivateGoalV2Channel: PropTypes.func,
  unsubscribePrivateGoalV2Channel: PropTypes.func,
  subscribePresenceStreamExclusive: PropTypes.func,
  unsubscribePresenceStreamExclusive: PropTypes.func,
  shouldSubscribeStreamChannel: PropTypes.bool,
  exclusivePrivateStatus: PropTypes.string,
  exclusivePrivateBuyerId: PropTypes.string,
  isLivestreamModerator: PropTypes.bool,
};

LiveStreamPusherHandler.defaultProps = {
  streamId: null,
  pusherPreset: PRESET_SD,
  meId: null,
  fundingId: null,
  subscribeStreamChannel: () => null,
  subscribePrivateStreamViewerV2Channel: () => null,
  unsubscribeStreamChannel: () => null,
  unsubscribePrivateStreamViewerV2Channel: () => null,
  subscribePrivateGoalV2Channel: () => null,
  unsubscribePrivateGoalV2Channel: () => null,
  subscribePresenceStreamExclusive: () => null,
  unsubscribePresenceStreamExclusive: () => null,
  shouldSubscribeStreamChannel: true,
  exclusivePrivateStatus: null,
  exclusivePrivateBuyerId: null,
  isLivestreamModerator: false,
};

export default LiveStreamPusherHandler;
